import React, { useEffect } from "react";
import { Styles } from "react-modal";
import BasedModal, { IProps } from "../BaseModalComponents/BasedModal";
import {
    Container,
    FileName,
    ItemBlock,
    Label,
    Link,
    LinkBlock,
    ModalBody,
    SaveButton,
    Size,
    CopyImg as Copy,
} from "./styles";
import { handleCopy } from "../../utils/copyText";
import { useDispatch, useSelector } from "react-redux";
import { getLogsFile } from "store/reducers/LogsSlice";
import {
    downloadLogsFile
} from 'store/reducers/SettingsSlice';
import { useAppSelector } from "hooks/redux";

const style: Styles = {
    overlay: {
        position: "fixed",
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        position: "static",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        width: "330px",
        padding: 0,
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px",
    },
};

interface additionalProps {
    info: string;
}

function CombineLogsResultModal({
    isOpen,
    onRequestClose,
    info,
}: IProps & additionalProps) {
    const {
        id,
        local_file: link,
        size,
        ticker_name: tickerName,
        
    } = JSON.parse(info);
    const download_file_data = useAppSelector(state => state.logs.downloadFileData);
    const dispatch = useDispatch();

    const onDownloadBtnClick = (event: React.MouseEvent) => {
        
        dispatch(downloadLogsFile({
            link: download_file_data?.link
        }));

        if (onRequestClose) {
            onRequestClose(event);
        }
    };

    function calculatePrettySize(currentSize: number | null): string {
        if (!currentSize) {
            return "0Mb";
        }
        if (currentSize >= 1024) {
            return (currentSize / 1024).toFixed(2) + "Gb";
        }
        return `${currentSize}Mb`;
    }

    return (
        <BasedModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={style}
        >
            <Container>
                <ModalBody>
                    <ItemBlock>
                        <Label>Название файла</Label>
                        <FileName>
                            {tickerName || "Ошибка: имя не найдена"}
                        </FileName>
                    </ItemBlock>
                    <ItemBlock>
                        <Label>Размер</Label>
                        <Size>{calculatePrettySize(size)}</Size>
                    </ItemBlock>
                    <ItemBlock>
                        <Label>Ссылка на файл</Label>
                        <LinkBlock>
                            <Link title={link || "Ошибка: ссылка не найдена"}>
                                {link || "Ошибка: ссылка не найдена"}
                            </Link>
                            <Copy
                                title={link || "Ошибка: ссылка не найдена"}
                                onClick={() =>
                                    handleCopy(
                                        link || "Ошибка: ссылка не найдена"
                                    )
                                }
                            />
                        </LinkBlock>
                    </ItemBlock>
                    <SaveButton onClick={onDownloadBtnClick}>
                        Скачать
                    </SaveButton>
                </ModalBody>
            </Container>
        </BasedModal>
    );
}

export default CombineLogsResultModal;
